module.exports = __webpack_public_path__ + "img/logo.473b8352.png";